import { useConfirmStore } from "@shared/store/confirmStore";
import { AlertTriangle, Info } from "lucide-react";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import "./_confirm-dialog.scss";

export const ConfirmDialog = () => {
	const isOpen = useConfirmStore((s) => s.isOpen);
	const options = useConfirmStore((s) => s.options);
	const handleConfirm = useConfirmStore((s) => s.handleConfirm);
	const handleCancel = useConfirmStore((s) => s.handleCancel);

	useEffect(() => {
		if (!isOpen) return;
		const onKey = (e: KeyboardEvent) => {
			if (e.key === "Escape") handleCancel();
		};
		window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, [isOpen, handleCancel]);

	if (!isOpen || !options) return null;

	const variant = options.variant ?? "info";
	const Icon = variant === "info" ? Info : AlertTriangle;

	return createPortal(
		<div
			className="confirm-dialog"
			role="dialog"
			aria-modal="true"
			aria-labelledby="confirm-dialog-title"
		>
			<div
				className="confirm-dialog__overlay"
				onClick={handleCancel}
				aria-hidden="true"
			/>
			<div
				className={`confirm-dialog__content confirm-dialog__content--${variant}`}
			>
				<div className="confirm-dialog__icon">
					<Icon size={32} />
				</div>
				<h2 id="confirm-dialog-title" className="confirm-dialog__title">
					{options.title}
				</h2>
				<p className="confirm-dialog__message">{options.message}</p>
				<div className="confirm-dialog__actions">
					<button
						type="button"
						className="confirm-dialog__btn confirm-dialog__btn--cancel"
						onClick={handleCancel}
					>
						{options.cancelText ?? "Cancel"}
					</button>
					<button
						type="button"
						className={`confirm-dialog__btn confirm-dialog__btn--confirm confirm-dialog__btn--${variant}`}
						onClick={handleConfirm}
					>
						{options.confirmText ?? "Confirm"}
					</button>
				</div>
			</div>
		</div>,
		document.body,
	);
};
